import React from 'react';

import styles from './CircularLoader.module.css';

interface CircularLoaderProps {
    size?: number;
    thickness?: number;
    color?: string;
}

export const CircularLoader: React.FC<CircularLoaderProps> = ({
    size = 40,
    thickness = 4,
    color = '#1976d2',
}) => {
    const radius = (size - thickness) / 2;
    const circumference = 2 * Math.PI * radius;

    return (
        <svg className={styles.loader} width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
            <circle
                className={styles.circle}
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke={color}
                strokeWidth={thickness}
                fill="none"
                strokeDasharray={circumference}
                strokeDashoffset={circumference * 0.75}
            />
        </svg>
    );
};
